"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var ContactChooser = /** @class */ (function () {
    function ContactChooser() {
        this.sections = document.querySelectorAll("[".concat(constants_1.DATA_CONTACT_CHOOSER, "]"));
        if (!this.sections) {
            return;
        }
        this.contactChooser();
    }
    ContactChooser.prototype.contactChooser = function () {
        this.sections.forEach(function (item) {
            var trigger = item.querySelector("[".concat(constants_1.DATA_CONTACT_CHOOSER_TRIGGER, "]"));
            var target = item.querySelector("[".concat(constants_1.DATA_CONTACT_CHOOSER_TARGET, "]"));
            trigger.addEventListener('click', function () {
                target.classList.remove(constantsClasses_1.CLASS_D_NONE);
                trigger.classList.add(constantsClasses_1.CLASS_D_NONE);
            });
        });
    };
    return ContactChooser;
}());
exports.default = ContactChooser;
